module.exports = __webpack_public_path__ + "static/media/sf_600.6b7874dd34e4fe2d3f339b07a65f5306.png";